// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Amplitude {
  public static readonly SEARCH_RESULTS_FOUND = '[Order Search] Search results found';

  public static readonly SEARCH_RESULTS_FOUND__COUNT = 'Count';

  public static readonly NAVIGATE_TO_DETAIL = '[Order Search] Navigating to parcel detail';
}
